export enum Locales {
  EN = 'en',
  DA = 'da'
}

export enum LocalesName {
  EN = 'English',
  DA = 'Dansk'
}
